import { EventId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import {
    inviteeSummaryText,
    rosterSummaryCounts,
} from "components/calendar/invitee-copy";
import { trpc } from "components/rpc/trpc";
import { InternalLink } from "components/ui/internal-link";
import { Spinner } from "components/ui/spinner";
import React from "react";

interface EventGuestSummaryProps {
    eventId: EventId;
}

export const EventGuestSummary: React.FC<EventGuestSummaryProps> = props => {
    const { eventId } = props;
    const trpcClient = trpc.useTRPC();
    const query = useQuery({
        ...trpcClient.event.listInvitees.queryOptions({ id: eventId }),
    });
    return (
        <div>
            <h3 className="text-sm font-medium text-gray-500">Invitees</h3>
            <div className="mt-1 text-sm text-gray-900">
                {query.isPending ? <Spinner /> : null}
                {query.isError ? (
                    <span className="text-red-600">Could not load the guest list.</span>
                ) : null}
                {query.data ? inviteeSummaryText(rosterSummaryCounts(query.data)) : null}
            </div>
            <div className="mt-2">
                <InternalLink to={`/events/${eventId}`}>
                    Open event page to manage the guest list
                </InternalLink>
            </div>
        </div>
    );
};
